import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=0d32c737&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports